import type { Branded } from "@milaboratories/pl-model-common";
import type { PFrameInternal } from "@milaboratories/pl-model-middle-layer";

/**
 * See <https://datatracker.ietf.org/doc/html/rfc9110#section-8.8.3>
 *
 * Examples:
 *
 * ```text
 * ETag: "xyzzy"
 * ETag: W/"xyzzy"
 * ```
 */
export type Etag = Branded<string, "Etag">;

export function createETag(filename: PFrameInternal.ParquetFileName): Etag {
  // For immutable files, use URL-safe base64 encoded filename as ETag
  const filenameETag = Buffer.from(filename, "utf8").toString("base64url");
  return `"${filenameETag}"` as Etag;
}
